import { DSConfigurationService } from '@trp-dms-digital-shared/ds-ui-library-components/src/lib/configuration/digital-shared-configuration.service.js';
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';

@SingletonService
export class PopConfiguration {
  digitalSharedConfigurationService: DSConfigurationService;

  constructor() {
    this.digitalSharedConfigurationService = new DSConfigurationService();
  }

  public addConfiguration(key: string, configuration: unknown): void {
    this.digitalSharedConfigurationService.addConfiguration(key, configuration);
  }

  public getConfiguration(key: string): unknown {
    return this.digitalSharedConfigurationService.getConfiguration(key);
  }
}
